<template>
  <div class>
    <header class="header flex-box">
      <div @click="back" class="flex1 flex-box flex-v-c">
        <i class="iconfont icon-houtui"></i> 返回
      </div>
      <div class="headerTitle flex1 flex-box flex-hv-c">亲友圈详情</div>
      <div class="flex1"></div>
    </header>
    <div class="detailContent" v-cloak>
      <ul>
        <!--<h3 style="text-align: center;font-size: 0.3rem;font-weight: bold;">亲友圈详情</h3>-->
        <li class="flex-box flex-v-c bb">
          <div>亲友圈ID：</div>
          <div class="tip">{{data.id}}</div>
        </li>
        <li class="flex-box flex-v-c bb">
          <div>亲友圈昵称：</div>
          <div class>{{data.title}}</div>
        </li>
        <li class="flex-box flex-v-c bb">
          <div>代理ID：</div>
          <div class>{{data.memberId}}</div>
        </li>
        <li class="flex-box flex-v-c bb">
          <div>代理昵称：</div>
          <div class>{{data.nickname}}</div>
        </li>
        <li class="flex-box flex-v-c bb">
          <div>成为代理时间：</div>
          <div v-if="data.memberTime">{{data.memberTime | formatDate}}</div>
        </li>
        <li class="flex-box flex-v-c bb">
          <div>此代理绑定玩家数：</div>
          <div>{{data.bindCount}}</div>
        </li>
        <li class="flex-box flex-v-c bb">
          <div>亲友圈创建时间：</div>
          <div v-if="data.clubTime">{{data.clubTime | formatDate}}</div>
        </li>
        <li class="flex-box flex-v-c bb">
          <div>总人数：</div>
          <div>{{data.clubUserCount}}</div>
        </li>
        <li class="flex-box flex-v-c bb">
          <div>新用户人数：</div>
          <div>{{data.newPlayCnt}}</div>
        </li>
        <li class="flex-box flex-v-c bb">
          <div>新用户占比：</div>
          <div>{{data.rate}}%</div>
        </li>
        <!--<div @click="close" class="close flex-box flex-hv-c" style="margin-top: 1rem;">
          <div>关闭</div>
        </div>-->
      </ul>
    </div>
  </div>
</template>
<!--javascript-->
<script>
export default {
  props: ['id'],
  data: function () {
    return {
      data: {}
    }
  },
  methods: {
    getData() {
      this.$http.get('/club/detail', { params: { id: this.id } }).then((res) => {
        if (res.code == 0) {
          this.data = res.data
        } else {
          this.$toast(res.message)
        }
      })
    }/*,
      close(){
          this.$emit('ctrDetails',false)
      }*/,
    back() {
      this.$emit('ctrDetails', false)
    }
  },
  mounted: function () {
    this.getData()
  },
  created: function () {
  }

}
</script>
<!--styleSheet-->
<style scoped lang="less" rel="stylesheet/less">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.detail {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1;
  background: #fff;
  width: 100%;
  height: 100%;
}

.detailContent {
  -webkit-overflow-scrolling: touch;
  overflow: auto;
  height: calc(100vh - 1rem);
  padding: 10px;
}
ul li {
  padding: 0.2rem 0;
}
</style>



// WEBPACK FOOTER //
// src/components/club/detail.vue